<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>update</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;SMS Campañas Puntuales</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" lg="3">
            <v-select
              v-model="filtro.tipoCampania"
              :items="campanias"
              autocomplete="disabled"
              item-text="text"
              item-value="id"
              label="Seleccionar Campaña"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-select>
          </v-col>
          <v-col cols="2" lg="3">
            <v-select
              v-model="filtro.fechaOption"
              :items="fechaOptions"
              autocomplete="disabled"
              item-text="text"
              item-value="id"
              label="Período Campaña"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.modeloId"
              :items="listModeloSms"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Modelo SMS"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn dark color="green" @click="enviarSMS">
          Enviar sms&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        modeloId: 4,
        tipoCampania: 1,
        fechaOption: null,
      },
      listEmpresas: [],
      listModeloSms: [],
      listProductos: [],
      fechaOptions: [{ id: 1, text: '30 días' }, { id: 2, text: '60 días' }],
      campanias: [
        { id: 1, text: 'Aprobados No Liquidados (Sucursal)' },
        { id: 2, text: 'Aprobados No Liquidados (OnLine)' },
      ],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadModeloSms();
    this.loadProductos();

    this.filtro.fecha = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.listEmpresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadModeloSms() {
      this.loading = true;
      try {
        var result = await http.get('modelossms');

        this.listModeloSms = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (this.filtro.empresaId === 0) {
        this.alertWarning('Debe seleccionar una Empresa.');
        return false;
      }
      if (this.filtro.fechaOption === null) {
        this.alertWarning('Debe seleccionar un Período.');
        return false;
      }
      if (this.filtro.tipoCampania === 0) {
        this.alertWarning('Debe seleccionar una Campaña.');
        return false;
      }
      if (this.filtro.modeloId === 0) {
        this.alertWarning('Debe seleccionar un Modelo.');
        return false;
      }
      return true;
    },
    async enviarSMS() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        console.log(this.filtro);

        await http
          .post(
            'gestion/envioSmsCampaniaPuntual',
            JSON.stringify({ parametros: this.filtro })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess('Se enviaron correctamente los SMS');
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
